export enum CartItemType {
  RESERVATION = 'hotelreservation'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/shopping-cart/cart-item-type.model.ts